import { CSSProperties } from "react";
import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_NESTED_INDENT_PX,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewLineGroup } from "../note-preview-types";

export interface ReportBulletGroupProps {
  group: NotePreviewLineGroup;
  style?: CSSProperties;
}

const textStyle: CSSProperties = {
  fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  lineHeight: 1.5,
  color: NOTE_PREVIEW_TEXT_COLOR,
  breakInside: "avoid",
};

/**
 * A sub-label with one bullet per selection, as the ROS block prints "Eyes"
 * over "PERRLA" and "Color L". Untitled groups print as plain paragraphs.
 * Plain inline-styled elements so the PDF capture matches the screen.
 */
const ReportBulletGroup = ({ group, style }: ReportBulletGroupProps) => (
  <div
    style={{
      marginLeft: group.isNested ? NOTE_PREVIEW_NESTED_INDENT_PX : 0,
      marginBottom: 6,
      ...style,
    }}
  >
    {group.title && !group.isInline && (
      <div style={{ ...textStyle, breakAfter: "avoid" }}>{group.title}</div>
    )}
    {group.isInline ? (
      <p style={{ ...textStyle, margin: "2px 0", whiteSpace: "pre-line" }}>
        {group.items.join(" ")}
      </p>
    ) : group.isBulleted ? (
      <>
        {group.items.length > 0 && (
          <ul style={{ margin: "2px 0 0", paddingLeft: 18 }}>
            {group.items.map((item, index) => (
              <li key={index} style={textStyle}>
                {item}
              </li>
            ))}
          </ul>
        )}
        {group.paragraphs.map((paragraph, index) => (
          <p key={index} style={{ ...textStyle, margin: "4px 0 0 18px" }}>
            {paragraph}
          </p>
        ))}
      </>
    ) : (
      group.items.map((item, index) => (
        <p key={index} style={{ ...textStyle, margin: "2px 0" }}>
          {item}
        </p>
      ))
    )}
  </div>
);

export default ReportBulletGroup;
